import { render, staticRenderFns } from "./AdminSupportStaffModalRoot.vue?vue&type=template&id=fbff2406&scoped=true"
import script from "./AdminSupportStaffModalRoot.vue?vue&type=script&lang=js"
export * from "./AdminSupportStaffModalRoot.vue?vue&type=script&lang=js"
import style0 from "./AdminSupportStaffModalRoot.vue?vue&type=style&index=0&id=fbff2406&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbff2406",
  null
  
)

export default component.exports